import Vue from "vue";
import { ElLoadingComponent } from 'element-ui/types/loading';
import { MESSAGE } from "@/model/Message";

export default class extends Vue {
  elLoading: ElLoadingComponent | null = null;
  loadingText: string = MESSAGE.Loading;

  // 画面全体にローディングマスクを表示する
  show() {
    // 二重に表示しない
    this.hide();

    this.elLoading = this.$loading({
      target: '#app',
      text: this.loadingText
    });
  }

  hide() {
    if (this.elLoading !== null) {
      this.elLoading.close();
      this.elLoading = null;
    }
  }
}
